// eslint-disable-next-line import/prefer-default-export
var SIGN_OUT_REASONS = {
  SIGNED_OUT: 'sign-out',
  INACTIVE: 'inactive',
  MAX_SESSION: 'session'
};export{SIGN_OUT_REASONS};